/* lp-feature-tabs — <lp-feature-tabs>: feature items beside one media.
   Desktop (≥ 48rem): an accordion; a head opens its item and closes the rest. Mobile: a snap carousel; the card
   nearest the middle is the open one, and a tap slides a card into place. Auto-advance (data-autoplay seconds):
   only on screen and with motion allowed; pauses under the pointer and holds for 12s after a tap or swipe.
   YouTube (data-lp-youtube): the poster and play button are ours; the youtube-nocookie iframe is created on tap. */
(function () {
  'use strict';
  if (window.customElements.get('lp-feature-tabs')) return;
  var DESKTOP = window.matchMedia('(min-width: 48rem)');
  function motionOK() { return window.LP ? window.LP.motionOK : !window.matchMedia('(prefers-reduced-motion: reduce)').matches; }

  class LpFeatureTabs extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-lp-item]'));
      this.heads = Array.prototype.slice.call(this.querySelectorAll('[data-lp-tab]'));
      this.scroller = this.querySelector('[data-lp-items]');
      if (!this.items.length) return;
      this.index = 0; this.hover = false; this.held = false; this.inView = false;

      this.onClick = function (e) {
        var head = e.target.closest('[data-lp-tab]');
        if (head && self.contains(head)) { self.show(parseInt(head.dataset.lpTab, 10), { scroll: !DESKTOP.matches }); self.hold(); return; }
        var play = e.target.closest('[data-lp-play]');
        if (play && self.contains(play)) self.loadYoutube(play.closest('[data-lp-youtube]'));
      };
      this.addEventListener('click', this.onClick);

      /* mobile: the card nearest the middle is the open one */
      if (this.scroller) {
        var raf = 0;
        this.onScroll = function () {
          if (DESKTOP.matches || Date.now() < (self.settleUntil || 0)) return;
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () { self.syncFromScroll(); });
        };
        this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
        this.onTouch = function () { self.hold(); };
        this.scroller.addEventListener('touchstart', this.onTouch, { passive: true });
      }
      this.onEnter = function () { if (DESKTOP.matches) self.hover = true; };
      this.onLeave = function () { self.hover = false; };
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          self.inView = entries.some(function (en) { return en.isIntersecting; });
          if (self.inView) self.startAuto(); else self.stopAuto();
        }, { threshold: 0.25 });
        this.io.observe(this);
      }
      /* theme editor: selecting a Feature block opens it */
      this.onBlockSelect = function (e) {
        var it = e.target && e.target.closest ? e.target.closest('[data-lp-item]') : null;
        if (it && self.contains(it)) { self.show(parseInt(it.dataset.lpItem, 10), { scroll: true }); self.hold(); }
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.show(0);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('mouseenter', this.onEnter);
      this.removeEventListener('mouseleave', this.onLeave);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      if (this.scroller) { this.scroller.removeEventListener('scroll', this.onScroll); this.scroller.removeEventListener('touchstart', this.onTouch); }
      if (this.io) this.io.disconnect();
      this.stopAuto(); clearTimeout(this.holdTimer);
    }
    syncFromScroll() {
      var sr = this.scroller.getBoundingClientRect(), centre = sr.left + sr.width / 2, best = 0, bestD = Infinity;
      this.items.forEach(function (it, k) { var r = it.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - centre); if (d < bestD) { bestD = d; best = k; } });
      if (best !== this.index) this.show(best);
    }
    show(i, opts) {
      opts = opts || {};
      if (i < 0 || i >= this.items.length) return;
      this.index = i;
      this.items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
      this.heads.forEach(function (h, k) { h.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      if (opts.scroll && this.scroller && !DESKTOP.matches) {
        var it = this.items[i], pad = parseFloat(getComputedStyle(this.scroller).scrollPaddingInlineStart) || 0;
        this.settleUntil = Date.now() + 700;
        this.scroller.scrollTo({ left: it.offsetLeft - this.scroller.offsetLeft - pad, behavior: motionOK() ? 'smooth' : 'auto' });
      }
    }
    startAuto() {
      var secs = parseInt(this.dataset.autoplay, 10) || 0, self = this;
      if (!secs || this.timer || this.items.length < 2 || !motionOK()) return;
      this.timer = setInterval(function () {
        if (self.hover || self.held || document.hidden) return;
        self.show((self.index + 1) % self.items.length, { scroll: true });
      }, secs * 1000);
    }
    stopAuto() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }
    hold() { var self = this; this.held = true; clearTimeout(this.holdTimer); this.holdTimer = setTimeout(function () { self.held = false; }, 12000); }
    loadYoutube(box) {
      var id = box && box.dataset.lpYoutube; if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
      iframe.title = box.dataset.lpLabel || 'Video';
      iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      box.innerHTML = ''; box.appendChild(iframe);
      this.stopAuto();
    }
  }
  window.customElements.define('lp-feature-tabs', LpFeatureTabs);
})();
